export const CardProductCode : {[x: string]: number} = Object.freeze({
    DreamCard       : 100921,
    PremierCard     : 100922,
    DirectCard      : 101007,
    WelcomeCard     : 103079,
    QuickCard       : 104560,
    MultiCurrency   : 101676,
    FamilyBlue      : 101687,
    FamilyPurple    : 101688
})

export const CardProductCodeName : {[x: number]: string} = Object.freeze({
    100921  : "Dream Card",
    100922  : "Premier Card",
    101007  : "Direct Card",
    103079  : "Welcome Card",
    104560  : "Quick Card",
    101676  : "Multi Currency",
    101687  : "FAMILY BLUE",
    101688  : "FAMILY PURPLE"
});

export const CardProductTabName : {[x: number]: string} = Object.freeze({
    100921  : "Dream",
    100922  : "Premier",
    101007  : "Direct",
    103079  : "Welcome",
    104560  : "Quick",
    101676  : "Multi",
    101687  : "BLUE",
    101688  : "PURPLE"
});

export const QUICK_CARD_REGISTER_MIN_VERSION = 795;